import { Link } from 'almanac-ui/icons/16'
import { useCopyBlockLink } from 'common/Prose/Toolbar/hooks/useCopyBlockLink'
import { InlineFormatDropdownMenuItem } from 'components/InlineFormatBar/components/InlineFormatDropdownMenuItem/InlineFormatDropdownMenuItem'
import { observer } from 'mobx-react-lite'
import { EditorView } from 'prosemirror-view'

export const InlineCopyBlockLinkFormatButton = observer(
  ({ view, callback }: { view: EditorView; callback?: () => void }) => {
    const { disabled, handleClick } = useCopyBlockLink(view)

    return (
      <InlineFormatDropdownMenuItem
        key={'copyCodeLink'}
        onClick={(event) => {
          handleClick(event)
          callback?.()
        }}
        isDisabled={disabled}
        icon={<Link />}
        label="Copy link to block"
      />
    )
  },
)
